export const SA_TEMPLATE_MAPPING = {
  "MONOGRAM | Monogram Preferred Builder Contract": "Monogram Preferred Builder",
  "MONOGRAM | Monogram Preferred Builder": "Monogram Preferred Builder",

  "PRICE SHEET | ABD/ARD Price List": "Air & Water Distributor",
  "PRICE SHEET | ABD/ARD Price List Limited": "Air & Water Distributor",
  "PRICE SHEET | ABD/ARD Price List Split": "Air & Water Distributor",

  "PRICE SHEET | Customer Specific Price List Contract- Modifiers": "Contract Distributor",

  "PRICE SHEET | AS-IS Price List": "Retail Sales",
  "PRICE SHEET | Customer Specific Price List- List Price": "Retail Sales",
  "PRICE SHEET | Customer Specific Price List- Modifiers": "Retail Sales",
  "PRICE SHEET | Customer Specific Price List- Net Price": "Retail Sales"
};


// WEBPACK FOOTER //
// ./src/App/components/common/priceTemplateMapping.js